<template>
  <div>
    <base-full-loader/>
  </div>
</template>

<script>
import { parseQueryString } from '@/utils/queryParser'
import { lsRemove, lsSave } from '@/utils/localStorageController'
import { customRouter } from '@/customRouter'

export default {
  name: 'page-verify-email-change',
  methods: {
    finishEmailChange () {
      const qs = parseQueryString()
      if (!qs.token || !qs.userId) {
        this.unsuccessfulAttempt()
      } else {
        this.$apiRequest.post('changelogin/verify', { token: decodeURIComponent(qs.token), email: decodeURIComponent(qs.userId) })
          .then(() => {
            lsSave('sc_changeEmailVerification', true)
            customRouter.goTo({ name: 'userAccount' })
          })
          .catch(e => {
            lsSave('sc_TokenExpired', true)
            lsRemove('sc_changeEmailVerification')
            customRouter.goTo({ name: 'registrationTokenExpired' })
          })
          .finally(() => {
            this.$loader.hide()
          })
      }
    },
    unsuccessfulAttempt () {
      lsSave('sc_tokenExpired', true)
      customRouter.goTo({ name: 'registrationTokenExpired' })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$loader.show(' ')

      this.finishEmailChange()
    })
  }
}
</script>
